import { render, staticRenderFns } from "./SecurityTabGeneral.vue?vue&type=template&id=79ab0a7e"
import script from "./SecurityTabGeneral.vue?vue&type=script&lang=js"
export * from "./SecurityTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports